/**
 * @generated SignedSource<<96d686b308589c0581cf2642b40e5315>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpSplitComponent_paymentAddresses$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Recipients_paymentAddresses">;
  readonly " $fragmentType": "NftPdpSplitComponent_paymentAddresses";
};
export type NftPdpSplitComponent_paymentAddresses$key = {
  readonly " $data"?: NftPdpSplitComponent_paymentAddresses$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpSplitComponent_paymentAddresses">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpSplitComponent_paymentAddresses",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Recipients_paymentAddresses"
    }
  ],
  "type": "PaymentAddresses",
  "abstractKey": null
};

(node as any).hash = "55af7d0055a95ddd7884a519d92744dc";

export default node;
